const ITEMS = [
  "2000+ Campaigns Run",
  "3.4× Avg ROAS Lift",
  "60+ D2C Stores Shipped",
  "₹2Cr+ Ad Spend Managed",
  "B2B · B2C · D2C",
  "Shopify Partner Workflows",
  "Amazon SmartBiz Specialists",
  
];

export default function StatsMarquee() {
  return (
    <section
      data-testid="stats-marquee"
      className="relative border-y border-white/10 bg-zinc-950 py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee gap-12 pr-12">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-12 text-zinc-300 whitespace-nowrap font-display text-2xl sm:text-3xl font-medium"
          >
            <span className="text-zinc-100">{item}</span>
            <span className="text-yellow-400/70 text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
